import { Drawer } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { LeftOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import EPButton from '@/components/EPButton/EPButton';
import EPIconButton from '@/components/EPButton/EPIconButton';
import CompressorDetailsTab from '@/comp/MapBuilder/nodes/nodeWidget/EditAssetDrawer/CompressorDetailsTab/CompressorDetailsTab';

import { AddAssetDrawerContainer } from './AddAssetDrawer.styles';
import { assetItemIconMapping } from '../AddAssetSelectorDrawer.utils';
import { getDeviceSuperType } from '@/comp/MapBuilder/nodes/nodeWidget/EditAssetDrawer/EditAssetDrawer.utils';

interface EditAssetDrawerProps {
  selectedDeviceType: string;
  parentContainerRef: React.RefObject<HTMLDivElement>;
  setSelectedDeviceType: (selectedDeviceType: string | null) => void;
  setIsAddAssetSelectorDrawerOpen: (isAddAssetSelectorDrawerOpen: boolean) => void;
}

const EditAssetDrawer = observer(
  ({
    selectedDeviceType,
    parentContainerRef,
    setSelectedDeviceType,
    setIsAddAssetSelectorDrawerOpen,
  }: EditAssetDrawerProps) => {
    const { t } = useTranslation();
    const [afterOpenChange, setAfterOpenChange] = useState(false);

    const onBackClick = () => setSelectedDeviceType(null);

    const onCloseClick = () => {
      setSelectedDeviceType(null);
      setIsAddAssetSelectorDrawerOpen(false);
    };

    const onMouseAction = e => e.stopPropagation();

    return (
      <Drawer
        open={!!selectedDeviceType}
        width={400}
        closeIcon={false}
        closable={false}
        destroyOnClose
        afterOpenChange={setAfterOpenChange}
        push={false}
        mask={false}
        getContainer={parentContainerRef.current}
        rootStyle={{ position: 'absolute' }}
      >
        <AddAssetDrawerContainer
          onMouseDown={onMouseAction}
          onMouseUp={onMouseAction}
          onTouchStart={onMouseAction}
          onTouchEnd={onMouseAction}
          onWheel={onMouseAction}
        >
          <div className="header">
            <EPButton icon={<LeftOutlined />} onClick={onBackClick} type="text">
              {t('back')}
            </EPButton>
            <EPIconButton icon={<MenuUnfoldOutlined />} onClick={onCloseClick} size="large" />
          </div>
          {selectedDeviceType && (
            <div className="body-title">
              {t('new', {
                device: t(`${getDeviceSuperType(assetItemIconMapping[selectedDeviceType]?.types[0])}Details`),
              })}
            </div>
          )}
          <CompressorDetailsTab
            entity={{ deviceType: assetItemIconMapping[selectedDeviceType]?.types[0] }}
            afterOpenChange={afterOpenChange}
          />
        </AddAssetDrawerContainer>
      </Drawer>
    );
  },
);

export default EditAssetDrawer;
